import { Reducer } from "@reduxjs/toolkit";
import { UrlExternaState, UrlExternaTypes } from "./types";

const INITIAL_STATE: UrlExternaState = {
    data: {
        table: null,
        urlExterna: null
    },
    error: false,
    errorMessage: null,
    loading: false,
    loadingTable: false,
    loadingPersis: false,
    loadingInativacao: false,
};

const reducer: Reducer<UrlExternaState> = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case UrlExternaTypes.URL_EXTERNA_TABLE_REQUEST:
            return {
                ...state,
                error: false,
                loadingTable: true,
            };
        case UrlExternaTypes.URL_EXTERNA_TABLE_REQUEST_SUCCESS:
            return {
                ...state,
                error: false,
                loadingTable: false,
                data: {
                    ...state.data,
                    table: action.payload.data
                }
            };
        case UrlExternaTypes.URL_EXTERNA_TABLE_REQUEST_FAILURE:
            return {
                ...state,
                error: true,
                loadingTable: false,
                errorMessage: action.payload.err,
                data: {
                    ...state.data,
                    table: null
                }
            };

        case UrlExternaTypes.URL_EXTERNA_INATIVA_REQUEST:
            return {
                ...state,
                error: false,
                loading: true,
                loadingInativacao: true,
            };
        case UrlExternaTypes.URL_EXTERNA_INATIVA_REQUEST_SUCCESS:
            alert('Ação realizada com sucesso!');
            return {
                ...state,
                error: false,
                loading: false,
                loadingInativacao: false,
            };
        case UrlExternaTypes.URL_EXTERNA_INATIVA_REQUEST_FAILURE:
            return {
                ...state,
                error: true,
                loading: false,
                loadingInativacao: false,
                errorMessage: action.payload.err,
            };

        case UrlExternaTypes.URL_EXTERNA_ATIVA_REQUEST:
            return {
                ...state,
                error: false,
                loading: true,
                loadingInativacao: true,
            };
        case UrlExternaTypes.URL_EXTERNA_ATIVA_REQUEST_SUCCESS:
            alert('Ação realizada com sucesso!');
            return {
                ...state,
                error: false,
                loading: false,
                loadingInativacao: false,
            };
        case UrlExternaTypes.URL_EXTERNA_ATIVA_REQUEST_FAILURE:
            return {
                ...state,
                error: true,
                loading: false,
                loadingInativacao: false,
                errorMessage: action.payload.err,
            };

        case UrlExternaTypes.URL_EXTERNA_DATA_REQUEST:
            return {
                ...state,
                error: false,
                loading: true,
            };
        case UrlExternaTypes.URL_EXTERNA_DATA_REQUEST_SUCCESS:
            return {
                ...state,
                error: false,
                loading: false,
                data: {
                    ...state.data,
                    urlExterna: action.payload.data
                }
            };
        case UrlExternaTypes.URL_EXTERNA_DATA_REQUEST_FAILURE:
            return {
                ...state,
                error: true,
                loading: false,
                errorMessage: action.payload.err,
                data: {
                    ...state.data,
                    urlExterna: null
                }
            };

        case UrlExternaTypes.CLEAR_URL_EXTERNA_DATA:
            return {
                ...state,
                error: false,
                loading: false,
                data: {
                    ...state.data,
                    urlExterna: null
                }
            };

        case UrlExternaTypes.URL_EXTERNA_SAVE_REQUEST:
            return {
                ...state,
                error: false,
                loadingPersis: true,
            };
        case UrlExternaTypes.URL_EXTERNA_SAVE_REQUEST_SUCCESS:
            alert('Cadastro de Pesquisa Externa realizado com sucesso!');
            return {
                ...state,
                error: false,
                loadingPersis: false,
                data: {
                    ...state.data,
                    urlExterna: action.payload.data
                }
            };
        case UrlExternaTypes.URL_EXTERNA_SAVE_REQUEST_FAILURE:
            return {
                ...state,
                error: true,
                loadingPersis: false,
                errorMessage: action.payload.err,
            };

        case UrlExternaTypes.URL_EXTERNA_UPDATE_REQUEST:
            return {
                ...state,
                error: false,
                loadingPersis: true,
            };
        case UrlExternaTypes.URL_EXTERNA_UPDATE_REQUEST_SUCCESS:
            alert('Alteração de Pesquisa Externa realizado com sucesso!');
            return {
                ...state,
                error: false,
                loadingPersis: false,
                data: {
                    ...state.data,
                    urlExterna: action.payload.data
                }
            };
        case UrlExternaTypes.URL_EXTERNA_UPDATE_REQUEST_FAILURE:
            return {
                ...state,
                error: true,
                loadingPersis: false,
                errorMessage: action.payload.err,
            };

        case UrlExternaTypes.URL_EXTERNA_PUSH_REQUEST:
            return {
                ...state,
                error: false,
                loading: true,
            };
        case UrlExternaTypes.URL_EXTERNA_PUSH_REQUEST_SUCCESS:
            alert('As notificações entraram na fila para envio! Pode levar alguns minutos para que os usuários recebam.');
            return {
                ...state,
                error: false,
                loading: false,
            };
        case UrlExternaTypes.URL_EXTERNA_PUSH_REQUEST_FAILURE:
            return {
                ...state,
                error: true,
                loading: false,
                errorMessage: action.payload.err,
            };

        default :
            return {
    ...state,
    error: false,
    loading: false,
    errorMessage: null
};
    }
};

export default reducer;